export const PROJECT_PRIORITY_OPTIONS = [
  { value: 0, label: 'Crise', className: 'bg-red-50 text-red-700 border-red-100' },
  { value: 1, label: 'Critique', className: 'bg-rose-50 text-rose-700 border-rose-100' },
  { value: 2, label: 'Urgent', className: 'bg-orange-50 text-orange-700 border-orange-100' },
  { value: 3, label: 'Fort', className: 'bg-amber-50 text-amber-700 border-amber-100' },
  { value: 4, label: 'Normal', className: 'bg-emerald-50 text-emerald-700 border-emerald-100' },
  { value: 5, label: 'Faible', className: 'bg-blue-50 text-blue-700 border-blue-100' },
  { value: 6, label: 'Opportuniste', className: 'bg-cyan-50 text-cyan-700 border-cyan-100' },
  { value: 7, label: 'Pause', className: 'bg-slate-100 text-slate-600 border-slate-200' },
];

export const DEFAULT_PROJECT_PRIORITY_VALUE = 4;

export const getProjectPriorityInfo = (value, fallbackValue = null) => {
  const resolvedValue = value === null || value === undefined || value === '' ? fallbackValue : value;
  if (resolvedValue === null || resolvedValue === undefined || resolvedValue === '') return null;
  const parsed = Number(resolvedValue);
  if (!Number.isInteger(parsed)) return null;
  return PROJECT_PRIORITY_OPTIONS.find((option) => option.value === parsed) || null;
};

export const getProjectPriorityValue = (project, fallbackValue = PROJECT_PRIORITY_OPTIONS.length) => {
  const raw = project?.pilotage_priority ?? project?.project_priority ?? project?.priority;
  if (raw === null || raw === undefined || raw === '') return fallbackValue;
  const parsed = Number(raw);
  return Number.isInteger(parsed) ? parsed : fallbackValue;
};
